<template>
  <div class="my-5 py-5 mx-5">
    <h1 class="text-center">Aliff Service Plans</h1>
    <div class="my-5">
      <b-row class="row-cols-1 row-cols-md-2 row-cols-lg-3  mb-5">
        <!-- Loop through each package in mydata -->
        <b-col v-for="(plan, index) in service.plans" :key="index" class="">
          <b-card class="text-center pricing-card h-100">
            <div>
              <h2>{{ plan.plan_name }}</h2>
              <div class="price">
                <h2 class="pricing-cost">
                  <template v-if="index === 2"> Free </template>
                  <template v-else>
                    {{
                      getSymbolFromCurrency(
                        plan.pp_currency ? plan.pp_currency : plan.plan_currency
                      )
                    }}
                    {{
                      addCommas(
                        plan.pp_price
                          ? removeGST(plan.pp_price, plan.pp_currency)
                          : removeGST(plan.plan_price, plan.plan_currency)
                      )
                    }}
                  </template>
                </h2>
                <div
                  v-if="
                    index !== 2 &&
                    (plan.plan_currency == 'INR' || plan.pp_currency == 'INR')
                  "
                  class="text-center"
                  style="color: #999"
                >
                  + 18% GST
                </div>
                <p class="fs-6" style="font-size: 13px">
                  {{ plan.plan_description }}
                </p>
                <a
                  v-if="index !== 2"
                  target="_blank"
                  href="http://app.aliff.in/"
                >
                  <button class="btn btn-pay-now-gradient w-100">
                    Pay Now
                  </button>
                </a>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <div
        class="pricing-plan-table animate__animated animate__pulse table-responsive"
      >
        <table class="table">
          <thead class="header">
            <tr>
              <th class="plan-lg-title">Compare Plans</th>
              <th
                v-for="(plan, index) in service.plans"
                :key="'plan_compare_' + plan.plan_id + '_' + index"
              >
                <div class="text-center">
                  <div class="plan-name">{{ plan.plan_name }}</div>
                  <!-- <div class="plan-price">
                    {{
                      getSymbolFromCurrency(
                        plan.pp_currency ? plan.pp_currency : plan.plan_currency
                      )
                    }}
                    {{
                      addCommas(
                        plan.pp_price
                          ? removeGST(plan.pp_price, plan.pp_currency)
                          : removeGST(plan.plan_price, plan.plan_currency)
                      )
                    }}
                  </div> -->
                </div>
              </th>
            </tr>
          </thead>
          <tbody
            class="alternate-stripped"
            v-for="(feature, feature_index) in service.features"
            :key="'feature_' + feature.feature_id + '_' + feature_index"
          >
            <tr>
              <td>{{ feature.feature_name }}</td>
              <td v-for="(plan, index) in service.plans" :key="index">
                <span v-if="plan.plan_features[feature_index].extra_text">
                  {{ plan.plan_features[feature_index].extra_text }}
                </span>
                <img
                  v-else-if="plan.plan_features[feature_index].spfm_id"
                  src="@/assets/imgs/blue-tick.svg"
                  class="img-fluid"
                />
                <img
                  v-else
                  src="@/assets/imgs/red-cross.svg"
                  class="img-fluid"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- <b-row>
        <b-col v-for="(pkg, index) in mydata" :key="index" class="">
          <b-card class="text-center pricing-card">
            <div>
              <h2>{{ pkg.title }}</h2>
              <div class="price">
                <h2 class="pricing-cost">{{ pkg.service_fee }}</h2>

                <p class="fs-6" style="font-size: 13px;"> + 18% GST</p>
                <button class="btn btn-pay-now-gradient w-100">
                  <a target="_blank" :href="pkg.rzp_link">Pay Now</a>
                </button>
              </div>

            </div>
          </b-card>
        </b-col>
      </b-row> -->
      <!-- <div class="premium py-2">
                <div
                  v-for="(feature, fIndex) in features[0].content"
                  :key="fIndex"
                  class="feature"
                >
                  <i
                    v-if="
                      features[0].content1[fIndex] === 'Y' &&
                        features[0].content2[fIndex] === 'Y' &&
                        features[0].content3[fIndex] === 'Y'
                    "
                    class="bi bi-check-circle-fill text-success"
                  ></i>
                  <i
                    v-else-if="
                      features[0].content1[fIndex] === 'N' &&
                        features[0].content2[fIndex] === 'N' &&
                        features[0].content3[fIndex] === 'N'
                    "
                    class="bi bi-x-circle-fill text-danger"
                  ></i>
                  {{ feature }}
                </div>
              </div> -->
      <!-- <button class="btn btn-pay-now-gradient bg-secondary-gradient w-100">
              Get Started
            </button> -->
    </div>
  </div>
</template>
<script>
import homeServices from "@/apiServices/homeServices";
import getSymbolFromCurrency from "currency-symbol-map";

export default {
  metaInfo: {
      title:
        "Elevate Your Success with Aliff's Premium Services",
      htmlAttrs: {
        lang: "en-US",
      },
    },
  data() {
    return {
      service: [],
      allFeatures: [],
      // showPlan: false,
      mydata: [
        {
          title: "Aliff Pro",
          service_fee: "₹95,000",
          discount: "15%",
          gst: " ₹80,750",
          rzp_link: "https://app.aliff.in/",
        },
        {
          title: "Aliff Basic",
          service_fee: "₹50,000",
          discount: "30%",
          gst: " ₹35,000",
          rzp_link: "https://app.aliff.in/",
        },
        {
          title: "Aliff Lite",
          service_fee: "Free",
          discount: "30%",
          gst: " ₹8,750",
          rzp_link: "https://app.aliff.in/",
        },
      ],
      features: [
        {
          content: [
            "Dedicated Admission Counselor",
            "Program & University Shortlisting",
            "10 University Applications",
            "Country Selection (Out of 19+)",
            "University Admission Support",
            "SOP - Resume - Profile",
            "Education Loan Assistance",
            "Dedicated Visa Counselor",
            "Visa Support",
            "Student Guide",
            "Accommodation Support",
            "Ticket & Forex Assistance",
            "Essential Travel Kit",
            "Priority Service",
            "IELTS Coaching",
            "Self Assessment Test",
            "Mentoring by Expert",
            "Job Placement Preparation",
            "Global Placement Assistance",
            "Stay Healthy Plan",
            "Alumni Mentoring",
            "Personal Grooming",
            "Cross Culture & Diversity Training",
          ],
          content1: [
            "Y",
            "Y",
            "10",
            "Out of 19+",
            "Y",
            "Y",
            "Y",
            "Y",
            "Y",
            "Y",
            "Y",
            "Y",
            "Y",
            "Y",
            "Y",
            "Y",
            "Y",
            "Y",
            "Y",
            "Y",
            "Y",
            "Y",
            "Y",
          ],
          content2: [
            "Y",
            "Y",
            "5",
            "Out of 19+",
            "Y",
            "Y",
            "Y",
            "Y",
            "Y",
            "Y",
            "Y",
            "Y",
            "Y",
            "N",
            "Y",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
          ],
          content3: [
            "Y",
            "Y",
            "3",
            "Out of 19+",
            "Y",
            "Done For You",
            "Self Help",
            "N",
            "Self Help",
            "N",
            "Self Help",
            "Limited Support",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
          ],
        },
      ],
    };
  },
  methods: {
    getSymbolFromCurrency,
    removeGST(total, currency) {
      if (currency != "INR") {
        return total;
      }

      let taxPercentage = 0.18;
      let withTaxAmount = total / (1 + taxPercentage);
      return withTaxAmount.toFixed(0);
    },
    // clickShowPlan() {
    //   this.showPlan = !this.showPlan;
    // },
    addCommas(amt) {
      return amt.toLocaleString("en-IN");
    },
    async getService() {
      try {
        const res = await homeServices.getServicesAndPlans({
          service_id: 8,
        });
        console.log(res);

        if (res.status) {
          this.service = res.data.data[0];
          console.log(this.service);
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
  beforeMount() {
    document.querySelector('meta[name="description"]').setAttribute('content',"Looking for exclusive premium services? Aliff Premium offers top-tier educational and career solutions tailored to your needs for ultimate success!.");
    this.getService();
  },
};
</script>
<style>
i.bi-check2,
i.bi-x {
  font-size: 22px;
}
.pricing-section {
  background-color: #f8f9fa;
  padding: 50px 0;
}

.pricing-card {
  border: 1px solid #dee2e6;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  transition: transform 0.3s;
  margin-bottom: 20px 20px; /* Add spacing between cards */
}

.pricing-card:hover {
  transform: scale(1.05);
}

/* .price {
  margin-bottom: 20px;
} */

.premium {
  text-align: left;
  padding-top: 20px;
}

.feature {
  display: flex;
  align-items: center;
  margin-bottom: 12px; /* Increase spacing between features */
}

.feature i {
  font-size: 24px;
  margin-right: 12px;
}
.premium div {
  gap: 10px !important;
  margin-bottom: 10px;
}
.premium div span {
  text-decoration: underline;
}
.row-cols-1 > *{
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/AliffPremiumPackages.vue